(function () {
  console.log('collection-enhancements.js loaded');

  function setActiveSwatch(card, swatch) {
    card.querySelectorAll('[data-swatch]').forEach(function (item) {
      item.classList.remove('is-active');
    });

    if (swatch) {
      swatch.classList.add('is-active');
    }
  }

  function getMainImage(card) {
    return card ? card.querySelector('[data-card-main-image]') : null;
  }

  function swapCardImage(card, swatch, lockSelection) {
    if (!card || !swatch) return;

    var img = getMainImage(card);
    if (!img) return;

    var newSrc = swatch.getAttribute('data-image-src');
    var newSrcset = swatch.getAttribute('data-image-srcset');

    if (!newSrc) return;

    img.setAttribute('src', newSrc);
    if (newSrcset) {
      img.setAttribute('srcset', newSrcset);
    }

    setActiveSwatch(card, swatch);

    if (lockSelection) {
      card.setAttribute('data-locked-swatch-src', newSrc);
      card.setAttribute('data-locked-swatch-srcset', newSrcset || '');
      card.setAttribute('data-locked-swatch-color', swatch.getAttribute('data-color') || '');
    }
  }

  function restoreDefaultImage(card) {
    if (!card) return;

    var img = getMainImage(card);
    if (!img) return;

    var defaultSrc = img.getAttribute('data-default-src');
    var defaultSrcset = img.getAttribute('data-default-srcset');

    if (defaultSrc) img.setAttribute('src', defaultSrc);
    if (defaultSrcset) img.setAttribute('srcset', defaultSrcset);

    setActiveSwatch(card, null);
  }

  function restoreLockedOrDefault(card) {
    if (!card) return;

    var img = getMainImage(card);
    if (!img) return;

    var lockedSrc = card.getAttribute('data-locked-swatch-src');
    var lockedSrcset = card.getAttribute('data-locked-swatch-srcset');
    var lockedColor = card.getAttribute('data-locked-swatch-color');

    if (lockedSrc) {
      img.setAttribute('src', lockedSrc);
      if (lockedSrcset) img.setAttribute('srcset', lockedSrcset);

      var lockedSwatch = null;
      card.querySelectorAll('[data-swatch]').forEach(function (item) {
        if ((item.getAttribute('data-color') || '') === (lockedColor || '')) {
          lockedSwatch = item;
        }
      });

      setActiveSwatch(card, lockedSwatch);
      return;
    }

    restoreDefaultImage(card);
  }

  function getSwatchFromEvent(event) {
    return event.target && event.target.closest ? event.target.closest('[data-swatch]') : null;
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var swatch = getSwatchFromEvent(event);
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var swatch = getSwatchFromEvent(event);
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      var card = swatch.closest('[data-product-card]');
      if (!card) return;

      swapCardImage(card, swatch, true);
    },
    true
  );

  document.addEventListener(
    'pointerover',
    function (event) {
      if (!window.matchMedia('(hover: hover)').matches) return;

      var swatch = getSwatchFromEvent(event);
      if (!swatch) return;

      var card = swatch.closest('[data-product-card]');
      if (!card) return;

      swapCardImage(card, swatch, false);
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      var swatch = getSwatchFromEvent(event);
      if (!swatch) return;

      var card = swatch.closest('[data-product-card]');
      if (!card) return;

      swapCardImage(card, swatch, false);
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      if (!window.matchMedia('(hover: hover)').matches) return;

      var card = event.target && event.target.closest ? event.target.closest('[data-product-card]') : null;
      if (!card) return;

      var related = event.relatedTarget;
      if (related && card.contains(related)) return;

      restoreLockedOrDefault(card);
    },
    true
  );

  function attachInfiniteScroll(container) {
    if (!container) return;
    if (container.getAttribute('data-infinite-scroll-init') === 'true') return;

    var grid = container.querySelector('#product-grid');
    var sentinel = container.querySelector('[data-infinite-scroll-sentinel]');
    var status = container.querySelector('[data-infinite-scroll-status]');
    var controls = container.querySelector('[data-infinite-scroll-controls]');
    var pauseButton = container.querySelector('[data-infinite-scroll-toggle]');
    var loadButton = container.querySelector('[data-infinite-scroll-load]');
    var backToTopButton = container.querySelector('[data-collection-back-to-top]');
    var pauseStorageKey = 'shopbroInfiniteScrollPaused';
    var isPaused = false;
    var shopbroAutoLoadDelay = 2000;
    var shopbroAutoLoadTimer = null;

    try {
      isPaused = window.sessionStorage.getItem(pauseStorageKey) === '1';
    } catch (storageError) {
      isPaused = false;
    }

    console.log('Infinite scroll container found');
    console.log('Next page raw value:', container.getAttribute('data-next-page'));
    console.log('Grid found:', !!grid);
    console.log('Sentinel found:', !!sentinel);

    if (!grid || !sentinel) return;

    container.setAttribute('data-infinite-scroll-init', 'true');

    function getNextUrl() {
      return container.getAttribute('data-next-page');
    }

    function normalizeNextUrl(value) {
      if (!value) return '';

      var trimmed = String(value).trim();

      if (/^\d+$/.test(trimmed)) {
        var url = new URL(window.location.href);
        url.searchParams.set('page', trimmed);
        return url.toString();
      }

      if (trimmed.charAt(0) === '/') {
        return window.location.origin + trimmed;
      }

      return trimmed;
    }

    function setNextUrl(url) {
      container.setAttribute('data-next-page', url || '');
    }

    function isLoading() {
      return container.getAttribute('data-loading') === 'true';
    }

    function setLoading(value) {
      container.setAttribute('data-loading', value ? 'true' : 'false');
      container.classList.toggle('is-loading', !!value);
    }

    function scheduleAutoLoad() {
      if (isPaused || shopbroAutoLoadTimer || isLoading() || !normalizeNextUrl(getNextUrl())) return;
      shopbroAutoLoadTimer = window.setTimeout(function () {
        shopbroAutoLoadTimer = null;
        loadNextPage(false);
      }, shopbroAutoLoadDelay);
    }

    async function loadNextPage(forceManual) {
      var nextUrl = normalizeNextUrl(getNextUrl());
      if (!nextUrl || isLoading() || (isPaused && !forceManual)) return;

      console.log('Loading next page:', nextUrl);

      setLoading(true);
      if (status) status.textContent = 'Loading more products';

      try {
        var response = await fetch(nextUrl, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error('Failed to load next page');

        var html = await response.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newContainer = doc.querySelector('#ProductGridContainer');
        var newGrid = newContainer ? newContainer.querySelector('#product-grid') : null;

        if (!newGrid) {
          setNextUrl('');
          disconnectAll();
          return;
        }

        var items = newGrid.querySelectorAll(':scope > .grid__item');

        var fragment = document.createDocumentFragment();

        items.forEach(function (item) {
          fragment.appendChild(item);
        });

        grid.appendChild(fragment);

        var newNextUrl = newContainer.getAttribute('data-next-page') || '';
        setNextUrl(newNextUrl);

        if (status) {
          status.textContent = items.length ? 'Loaded more products' : 'No more products';
        }

        if (!newNextUrl) {
          disconnectAll();
        }
      } catch (error) {
        console.error('Infinite scroll error:', error);
        if (status) status.textContent = 'Unable to load more products';
      } finally {
        setLoading(false);
        updateControls();
      }
    }

    function nearBottom() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var fullHeight = document.documentElement.scrollHeight;

      return scrollTop + viewportHeight >= fullHeight - 800;
    }

    var scrollTicking = false;

    function onScroll() {
      if (scrollTicking) return;

      scrollTicking = true;
      window.requestAnimationFrame(function () {
        if (nearBottom() && !isPaused) {
          scheduleAutoLoad();
        }
        scrollTicking = false;
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !isPaused) {
            scheduleAutoLoad();
          }
        });
      },
      {
        root: null,
        rootMargin: '1200px 0px',
        threshold: 0
      }
    );

    function disconnectAll() {
      observer.disconnect();
      window.removeEventListener('scroll', onScroll);
    }

    function updateControls() {
      var hasNextPage = !!normalizeNextUrl(getNextUrl());
      if (controls) controls.hidden = !hasNextPage;
      if (pauseButton) {
        pauseButton.hidden = !hasNextPage;
        pauseButton.textContent = isPaused ? 'Resume auto-loading' : 'Pause auto-loading';
        pauseButton.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
      }
      if (loadButton) loadButton.hidden = !hasNextPage || !isPaused;
    }

    function setPaused(value) {
      isPaused = !!value;
      if (isPaused && shopbroAutoLoadTimer) {
        window.clearTimeout(shopbroAutoLoadTimer);
        shopbroAutoLoadTimer = null;
      }
      try {
        window.sessionStorage.setItem(pauseStorageKey, isPaused ? '1' : '0');
      } catch (storageError) {
        // Session storage can be unavailable in strict privacy modes.
      }
      updateControls();
      if (!isPaused && nearBottom()) scheduleAutoLoad();
    }

    if (pauseButton) {
      pauseButton.addEventListener('click', function () {
        setPaused(!isPaused);
      });
    }
    if (loadButton) {
      loadButton.addEventListener('click', function () {
        loadNextPage(true);
      });
    }
    if (backToTopButton) {
      var updateBackToTop = function () {
        backToTopButton.hidden = (window.pageYOffset || document.documentElement.scrollTop) < 400;
      };
      backToTopButton.addEventListener('click', function () {
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
      window.addEventListener('scroll', updateBackToTop, { passive: true });
      updateBackToTop();
    }

    observer.observe(sentinel);
    window.addEventListener('scroll', onScroll, { passive: true });
    updateControls();

    if (nearBottom() && !isPaused) {
      scheduleAutoLoad();
    }
  }

  function initInfiniteScroll() {
    document.querySelectorAll('[data-infinite-scroll]').forEach(function (container) {
      attachInfiniteScroll(container);
    });
  }

  document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  document.addEventListener('shopify:section:load', initInfiniteScroll);
})();